<!--主课题-->
<template>
    <div class="app-container">
        <el-card class="mb15">
            <el-row>
                <el-col v-has-btn="'1,2'" :span="8" class="mb0">
                    <el-button v-has-btn="'1,2'" type="primary" @click="handleAdd">创建课题</el-button>
                </el-col>
                <el-col :span="16" class="mb0">
                </el-col>
            </el-row>
        </el-card>
        <el-card>
            <el-form :model="queryParams" ref="queryForm" :inline="true" label-width="68px"
                     @submit.native.prevent="handleQuery">
                <el-row class="mt15">
                    <el-col :span="6" class="mb0">
                        <el-form-item label="课题状态">
                            <el-select clearable @change="getPageTopic()" v-model="queryParams.status" placeholder="请选择">
                                <el-option v-for="item in statusList" :key="item.value" :label="item.name"
                                           :value="item.value" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" class="mb0">
                        <el-form-item label="课题级别">
                            <el-select clearable @change="getPageTopic()"  v-model="queryParams.topicLevel" placeholder="请选择">
                                <el-option v-for="item in topicLevelList" :key="item.value" :label="item.name"
                                           :value="item.value" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" class="mb0">
                        <el-form-item label="课题方向">
                            <el-select clearable @change="getPageTopic()"  v-model="queryParams.topicClassifyKey" placeholder="请选择">
                                <el-option v-for="item in topicClassifyList" :key="item.dictKey" :label="item.dictValue"
                                           :value="item.dictKey" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" class="mr0 mb0">
                        <el-form-item class="pull-right">
                            <el-input v-model="queryParams.topicName" placeholder="请输入课题名称" class="input-with-select">
                                <template #append>
                                    <el-button @click="handleQuery" type="primary" icon="el-icon-search" />
                                </template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <el-divider />
            <div class="bre9e mt15">
                <el-table header-cell-class-name="bgf2" show-overflow-tooltip
                          @current-change="handleCurrentChange"
                          height="calc(100vh - 360px)"
                          :data="dataList"
                          highlight-current-row>
                    <el-table-column type="index" align="center" label="序号" width="60" />
                    <el-table-column width="90" align="center" label="课题状态" prop="status">
                        <template #default="scope">
                            <div v-if="scope.row.status === 0">初始</div>
                            <div v-if="scope.row.status === 1">进行中</div>
                            <div v-if="scope.row.status === 2">已结束</div>
                        </template>
                    </el-table-column>
                    <el-table-column width="200" align="center" label="课题名称" prop="topicName">
                        <template #default="scope">
                            <div :title="scope.row.topicName" style="color: #409efe;" class="text-one cursor">
                                {{ scope.row.topicName }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column width="100" align="center" label="课题级别" prop="topicLevel">
                        <template #default="scope">
                            <div v-if="scope.row.topicLevel === '1'">国家级课题</div>
                            <div v-if="scope.row.topicLevel === '2'">省级课题</div>
                            <div v-if="scope.row.topicLevel === '3'">市级课题</div>
                            <div v-if="scope.row.topicLevel === '4'">区县课题</div>
                            <div v-if="scope.row.topicLevel === '5'">学校课题</div>
                        </template>
                    </el-table-column>
                    <el-table-column width="100" align="center" label="课题方向" prop="topicClassifyName">
                    </el-table-column>
                    <el-table-column width="200" align="center" label="课题单位" prop="orgNames">
                    </el-table-column>
                    <el-table-column width="160" align="center" label="课题负责人" prop="leaderNames">
                    </el-table-column>
                    <el-table-column width="160" align="center" label="发布时间" prop="createTime">
                        <template #default="scope">
                            <div>
                                {{ timestampToTime(scope.row.createTime) }}
                            </div>
                        </template>
                    </el-table-column>

                    <el-table-column fixed="right" width="100" label="操作" align="center"
                                     class-name="small-padding fixed-width">
                        <template #default="scope">
                            <el-popover placement="bottom" trigger="click" :width="120" popper-style="padding: 5px 0 0">
                                <template #reference>
                                    <el-button>操作</el-button>
                                </template>
                                <template #default>
                                    <div>
                                        <div class="text-item" v-has-btn="'1,2'">
                                            <el-text type="primary" @click="handleUpdate(scope.row)">编辑</el-text>
                                        </div>
                                        <div class="text-item" v-if="this.role==1||this.role==2||this.userId==scope.row.leader||(scope.row.checkUsers&&scope.row.checkUsers.includes(this.userId))" >
                                            <el-text type="primary" @click="handleManager(scope.row)">管理</el-text>
                                        </div>
                                        <div class="text-item" v-if="scope.row.status===2&&(this.role==1||this.role==2||this.userId==scope.row.leader||(scope.row.checkUsers&&scope.row.checkUsers.includes(this.userId)))" >
                                            <el-text type="primary" @click="handleRelease(scope.row)">发布</el-text>
                                        </div>
                                        <el-popconfirm confirm-button-text="是" cancel-button-text="否" :icon="InfoFilled"
                                                       icon-color="#626AEF" title="确定删除该课题" @confirm="handleDelete(scope.row)">
                                            <template #reference>
                                                <div class="text-item" v-has-btn="'1,2,'">
                                                    <el-text type="primary" >删除</el-text>
                                                </div>
                                            </template>
                                        </el-popconfirm>
                                    </div>
                                </template>
                            </el-popover>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="zdyfy">
                <pagination class="zdyfy" :background="false" :pageSizes="[10, 20, 30]" :total="total"
                            :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize" @pagination="getPageTopic" />
            </div>
        </el-card>

    </div>
</template>

<script>
import { serviceUrl } from "@/utils/global"
import {timestampToTime} from "@/utils/date";
import {pageTopic} from "@/api/admin/topic"
import {queryDict, userList} from "@/api/admin/public";
import {deleteTopic} from "@/api/admin/topic";
export default {
    name: "topicIndex",
    components: {},
    data() {
        return {
            serviceUrl,
            token: this.$storage.get("token"),
            role:this.$storage.get("role") ,
            userId:JSON.parse(this.$storage.get("userInfo")).userId,
            statusList: [
                { name: '初始', value: 0 },
                { name: '进行中', value: 1 },
                { name: '已结束', value: 2 },
            ],
            topicLevelList:[
                { name: '国家级课题', value: 1 },
                { name: '省级课题', value: 2 },
                { name: '市级课题', value: 3 },
                { name: '区县课题', value: 4 },
                { name: '学校课题', value: 5 },
            ],
            topicClassifyList:[],
            timestampToTime,
            currentObj:{},
            total: 0,
            pageCount:0,
            dataList: [],
            loading: true,
            queryParams: {
                topicName: '',
                topicLevel: '',
                topicClassifyKey: '',
                status: '',
                pageNum: 1,
                pageSize: 10,
            },
        };
    },
    created() {
        this.getQueryDict();
        this.getPageTopic();
    },
    activated() {},
    watch: {},
    methods: {
        handleAdd(){
            this.$router.push({
                path: "/topicAdd",
            });
        },
        handleUpdate(row){
            this.$router.push({
                path: "/topicAdd",
                query: {
                    topicId: row.topicId,
                }
            });
        },
        handleManager(row){
            this.$router.push({
                path: "/topicManager",
                query: {
                    topicId: row.topicId,
                }
            });
        },
        handleDelete(row) {
            deleteTopic({ topicId: row.topicId }).then(res => {
                if (res.data.code === 1) {
                    this.$message.success("删除成功");
                    this.getPageTopic()
                } else {
                    this.$message.error("删除失败");
                }
            })
        },
        handleQuery() {
            this.getPageTopic()
        },
        handleCurrentChange(val) {
            this.currentObj = val;
        },
        getPageTopic(e){
            this.dataList = []
            if (e) {
                this.queryParams.pageNum = e.page;
                this.queryParams.pageSize = e.limit;
            }
            pageTopic(this.queryParams).then(res => {
                if (res.data.code === 1) {
                    this.dataList = res.data.data.list;
                    this.total = res.data.data.total;
                    this.pageCount = res.data.data.totalPage;
                }else{
                    this.$message.error("请求出错")
                }

            })
        },
        getQueryDict() {
            queryDict({ code: 'topic_classify' }).then(res => {
                this.topicClassifyList = res.data.data;
            })
        },
        handleRelease(row){
            this.$router.push({
                path: "/topicRelease",
                query: {
                    topicId: row.topicId,
                }
            });
        }
    }
};
</script>
<style scoped>
.content-container{
    width: calc(100% - 30px);
    height: calc(100% - 20px);
    background: #fff;
    margin-top: 10px;
    margin-left: 15px;
    padding: 20px;
}

.disnone /deep/ .el-upload-list {
    display: none;
}

/deep/ .el-input-group__append {
    background: var(--el-color-primary);
    color: #fff;
}

.csbbb {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding: 0 15px;
}

.zdp /deep/ .el-range-editor.el-input__wrapper {
    width: 100%;
}

.zzzdddyyy /deep/ .el-upload-list {
    margin: 0 !important;
}

.zzzdddyyy /deep/ .el-upload-list__item {
    display: none;
}

.pxbutton {
    width: 90px;
    padding: 7px 15px;
    text-align: center;
    cursor: pointer;
    border: 1px solid #e4e7ed;
    font-size: 13px;
}

.filtxt {
    color: #409efe;
    margin: 8px 0;
}

.avatar-uploader .avatar {
    width: 178px;
    height: 178px;
    display: block;
    object-fit: cover;
}

.el-table /deep/ .hidden-row {
    display: none;
}

.avatar-uploader /deep/ .el-upload {
    border: 1px dashed var(--el-border-color);
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: var(--el-transition-duration-fast);
}

.avatar-uploader .el-upload:hover {
    border-color: var(--el-color-primary);
}
</style>
